module.exports = __webpack_public_path__ + "static/img/rrs2020.b684c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/rrs2020.png
// module id = wviW
// module chunks = 0